module.exports = "/wp-content/themes/onnit/script/cart/dist/activeBUpsellBg-60aa0a56.jpg";